const availableLanguages = [
  {
    code: "tr",
    name: "Türkçe",
  },
  {
    code: "en",
    name: "English",
  },
];

export default availableLanguages;
